import httpClientService from '@/services/httpClientService';

export default {
	getGridViews: () =>
		httpClientService.Get('/ActivityBuilderModule/api/GridViews'),
	getGridViewFieldsByActivityId: (id) =>
		httpClientService.Get(
			`/ActivityBuilderModule/api/GridViewFields/GetGridViewFieldsByActivityId/${id}`
		),
	getUsedGridViewFieldsByActivityId: (id) =>
		httpClientService.Get(
			`/ActivityBuilderModule/api/GridViewFields/GetUsedGridViewFieldsByActivityId/${id}`
		),
	getGridViewFieldByDefaultEntity: (id) =>
		httpClientService.Get(
			`/ActivityBuilderModule/api/GridViewFields/GetGridViewFieldByDefaultEntity/${id}`
		),

	getActivities: () =>
		httpClientService.Get('/ActivityBuilderModule/api/Activities'),
	getActivityData: (payload) =>
		httpClientService.Post(
			`/ActivityBuilderModule/api/Activities/data`,
			payload
		),
	getActivityById: (id) =>
		httpClientService.Get(`/ActivityBuilderModule/api/Activities/${id}`),
	insertActivity: (item) =>
		httpClientService.Post('/ActivityBuilderModule/api/Activities', item),
	updateActivity: (item) =>
		httpClientService.Put(
			`/ActivityBuilderModule/api/Activities/${item.Id}`,
			item
		),
	deleteActivity: (id) =>
		httpClientService.Delete(
			`/ActivityBuilderModule/api/Activities?id=${id}`
		),
	cloneActivity: (item) =>
		httpClientService.Post(
			'ActivityBuilderModule/api/Activities/ActivityClone',
			item
		),

	getComputedFieldsByActivityId: (id) =>
		httpClientService.Get(
			`/ActivityBuilderModule/api/ActivityComputedFields/GetByActivityId/${id}`
		),
	getComputedFieldById: (id) =>
		httpClientService.Get(
			`/ActivityBuilderModule/api/ActivityComputedFields/${id}`
		),
	insertComputedField: (item) =>
		httpClientService.Post(
			'/ActivityBuilderModule/api/ActivityComputedFields',
			item
		),
	updateComputedField: (item) =>
		httpClientService.Put(
			`/ActivityBuilderModule/api/ActivityComputedFields/${item.Id}`,
			item
		),
	deleteComputedField: (id) =>
		httpClientService.Delete(
			`/ActivityBuilderModule/api/ActivityComputedFields?id=${id}`
		),

	getStaticFields: () =>
		httpClientService.Get(
			'/ActivityBuilderModule/api/ActivityStaticFields'
		),
	getStaticFieldsByActivityId: (id) =>
		httpClientService.Get(
			`/ActivityBuilderModule/api/ActivityStaticFields/GetByActivityId/${id}`
		),
	insertStaticField: (item) =>
		httpClientService.Post(
			'/ActivityBuilderModule/api/ActivityStaticFields',
			item
		),
	updateStaticField: (item) =>
		httpClientService.Put(
			`/ActivityBuilderModule/api/ActivityStaticFields/${item.Id}`,
			item
		),
	deleteStaticField: (id) =>
		httpClientService.Delete(
			`/ActivityBuilderModule/api/ActivityStaticFields?id=${id}`
		),

	getGroupByConditions: (id) =>
		httpClientService.Get(
			`/ActivityBuilderModule/api/ActivityGroupByConditions/GetByActivityId/${id}`
		),
	insertGroupByCondition: (item) =>
		httpClientService.Post(
			'/ActivityBuilderModule/api/ActivityGroupByConditions',
			item
		),
	updateGroupByCondition: (item) =>
		httpClientService.Put(
			`/ActivityBuilderModule/api/ActivityGroupByConditions/${item.Id}`,
			item
		),
	deleteGroupByCondition: (id) =>
		httpClientService.Delete(
			`/ActivityBuilderModule/api/ActivityGroupByConditions?id=${id}`
		),

	getGrouByConditionFields: (id) =>
		httpClientService.Get(
			`/ActivityBuilderModule/api/ActivityGroupByConditionFields/GetConditionFieldsByActivityId/${id}`
		),
	insertGroupByConditionField: (item) =>
		httpClientService.Post(
			'/ActivityBuilderModule/api/ActivityGroupByConditionFields',
			item
		),
	updateGroupByConditionField: (item) =>
		httpClientService.Put(
			`/ActivityBuilderModule/api/ActivityGroupByConditionFields/${item.Id}`,
			item
		),
	deleteGroupByConditionField: (id) =>
		httpClientService.Delete(
			`/ActivityBuilderModule/api/ActivityGroupByConditionFields?id=${id}`
		),

	getGroupByConditionFieldList: (activityId) =>
		httpClientService.Get(
			`/ActivityBuilderModule/api/ActivityGroupByConditionFieldList/GetByActivityId/${activityId}`
		),
	insertGroupByConditionFieldList: (item) =>
		httpClientService.Post(
			'/ActivityBuilderModule/api/ActivityGroupByConditionFieldList',
			item
		),
	updateGroupByConditionFieldList: (item) =>
		httpClientService.Put(
			`/ActivityBuilderModule/api/ActivityGroupByConditionFieldList`,
			item
		),
	deleteGroupByConditionFieldList: (id) =>
		httpClientService.Delete(
			`/ActivityBuilderModule/api/ActivityGroupByConditionFieldList?id=${id}`
		),

	getActivityItems: (activityId) =>
		httpClientService.Get(
			`/ActivityBuilderModule/api/ActivityItems/GetByActivityId/${activityId}`
		),
	getActivityItemById: (id) =>
		httpClientService.Get(`/ActivityBuilderModule/api/ActivityItems/${id}`),
	getGroupByCriteria: (activityId, filters) =>
		httpClientService.Post(
			`/ActivityBuilderModule/api/ActivityItems/${activityId}/GetByGroupByCriteria`,
			filters
		),
	insertActivityItem: (item) =>
		httpClientService.Post(
			'/ActivityBuilderModule/api/ActivityItems',
			item
		),
	bulkInsertActivityItem: (item) =>
		httpClientService.Post(
			'/ActivityBuilderModule/api/ActivityItems/BulkInsert',
			item
		),
	updateActivityItem: (item) =>
		httpClientService.Put(
			`/ActivityBuilderModule/api/ActivityItems/${item.Id}`,
			item
		),
	deleteActivityItem: (id) =>
		httpClientService.Delete(
			`/ActivityBuilderModule/api/ActivityItems?id=${id}`
		),
	deleteAllActivityItemsByActivityId: (activityId) =>
		httpClientService.Delete(
			`/ActivityBuilderModule/api/ActivityItems/DeleteAllItemsByActivityId/${activityId}`
		),

	getActivityFilters: (id) =>
		httpClientService.Get(
			`/ActivityBuilderModule/api/ActivityFilters/GetByActivityId/${id}`
		),
	getActivityFiltersById: (id) =>
		httpClientService.Get(
			`/ActivityBuilderModule/api/ActivityFilters/${id}`
		),
	insertActivityFilters: (item) =>
		httpClientService.Post(
			'/ActivityBuilderModule/api/ActivityFilters',
			item
		),
	updateActivityFilters: (item) =>
		httpClientService.Put(
			`/ActivityBuilderModule/api/ActivityFilters/${item.ActivityId}`,
			item
		),
	deleteActivityFilters: (id) =>
		httpClientService.Delete(
			`/ActivityBuilderModule/api/ActivityFilters?id=${id}`
		),
};
